
export const ACCEPT_FILE_TYPE = [
  'image/png',
  'image/jpeg',
  'image/jpg'
]

export const ACCEPT_VIDEO_FILE_TYPE = [
  'video/mp4'
]

export const ACCEPT_FILE_SIZE = 5 * 1024 * 1024 // 2MB

export const ACCEPT_VIDEO_DURATION_SECONDS = 300 // 300秒

export const ACCEPT_VIDEO_FILE_SIZE = 100 * 1024 * 1024 // 100MB

export const FONT_FAMILY_LIST = ['Arial',
  'Comic Sans MS',
  'Courier New',
  'Georgia',
  'Lucida Sans Unicode',
  'Tahoma',
  'Times New Roman',
  'Trebuchet MS',
  'Verdana']

export const FONT_SIZE_LIST = [12, 14, 16, 18, 20, 22, 24, 26, 28, 36, 48, 72]

export const JOB_POSTER_SHOW_TYPE = {
  COMMON: 'COMMON',
  CUSTOM: 'CUSTOM',
  INSTRUCTIONS: 'INSTRUCTIONS'
}
